"use client";

import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TuCambioComienzaAqu() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="4343" id="tu-cambio-comienza-aquí" className="dark relative overflow-hidden bg-background text-foreground" style={{
    minHeight: "70vh"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "repeating-linear-gradient(45deg, var(--foreground) 0, var(--foreground) 1px, transparent 1px, transparent 6px), repeating-linear-gradient(-45deg, var(--foreground) 0, var(--foreground) 1px, transparent 1px, transparent 6px)",
      backgroundSize: "240px 240px, 240px 240px"
    }} />

      <div className="relative mx-auto flex min-h-[70vh] max-w-[900px] items-center px-6 py-24 sm:px-10 lg:py-32">
        <div ref={ref} className={`relative w-full transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <span aria-hidden="true" className="absolute -top-4 -left-4 h-10 w-10 border-t border-l" style={{
          borderColor: "var(--primary)"
        }} />
          <span aria-hidden="true" className="absolute -bottom-4 -right-4 h-10 w-10 border-b border-r" style={{
          borderColor: "var(--primary)"
        }} />

          <div className="flex flex-col items-center text-center">
            {}
            <p className="font-default text-xs uppercase tracking-[0.35em] text-primary !font-bold sm:text-sm" style={{
            letterSpacing: "0.35em"
          }}>
              Tu consulta personalizada
            </p>

            {}
            <h2 className="font-default mt-8 font-medium leading-[0.95] text-foreground !text-7xl" style={{
            fontSize: "clamp(56px, 8vw, 140px)"
          }}>
              <span className="block !text-8xl">Comienza tu</span>
              <span className="block !text-8xl">
                transformación <em className="italic text-primary">capilar</em>
              </span>
              <span className="block !text-8xl">hoy mismo</span>
            </h2>

            {}
            <p className="mt-10 max-w-[640px] font-default text-foreground/85" style={{
            fontSize: "22px",
            lineHeight: 1.5
          }}>
              Cuéntanos sobre tus inquietudes. Nuestro equipo médico analizará tu caso y te contactará en menos de 48 horas para coordinar una valoración profesional.
            </p>

            {}
            <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild className="h-[52px] px-8 text-base bg-primary text-primary-foreground hover:bg-primary/90 tracking-wide">
                <Link href="https://msinstitutocapilar.com/contacto/" newTab>Solicitar consulta gratuita →</Link>
              </Button>

              <Button asChild variant="outline" className="h-[52px] px-8 text-base bg-transparent border border-primary text-primary hover:bg-primary hover:text-white tracking-wide">
                <Link href="https://msinstitutocapilar.com/contacto/" newTab>Contactar con la clínica</Link>
              </Button>
            </div>

            {}
            <div className="mt-10 flex flex-wrap items-center justify-center gap-x-4 gap-y-3 font-default text-xs sm:text-sm text-muted-foreground">
              <Link to="tel:+34626475620" className="inline-flex items-center gap-2 hover:text-primary transition-colors">
                <Phone className="h-3.5 w-3.5" />
                <span>+34 626 475 620</span>
              </Link>
              <span aria-hidden="true" className="text-primary">◆</span>
              <Link to="mailto:info@msinstitutocapilar.com" className="inline-flex items-center gap-2 hover:text-primary transition-colors">
                <Mail className="h-3.5 w-3.5" />
                <span>info@msinstitutocapilar.com</span>
              </Link>
              <span aria-hidden="true" className="text-primary">◆</span>
              <span className="inline-flex items-center gap-2">
                <MapPin className="h-3.5 w-3.5" />
                <Link className="underline cursor-pointer" href="https://maps.app.goo.gl/Ro1y5PCPERxrhBy39" newTab><span>C/ Cruces 7, Las Rozas, Madrid</span></Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}